/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientCaseModel } from '../../models/patient-case-model';

export interface PatientCaseListPatientIdGet$Params {
  patientId: string;
}

export function patientCaseListPatientIdGet(http: HttpClient, rootUrl: string, params: PatientCaseListPatientIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientCaseModel>>> {
  const rb = new RequestBuilder(rootUrl, patientCaseListPatientIdGet.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<PatientCaseModel>>;
    })
  );
}

patientCaseListPatientIdGet.PATH = '/Patient/CaseList/{patientId}';
